<template>
  <div>
    <!-- Main Content -->
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="row justify-content-center mt-2">
              <button class="btn btn-add" id="v-step-0" @click="startTour">
                Iniciar Tour de Cadastro
              </button>
            </div>
            <div class="card-header">
              <div class="card-title">
                {{
                  workstations.id
                    ? "Editar Estação de Trabalho"
                    : "Cadastrar Estação de Trabalho"
                }}
              </div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="row">
                      <div class="col-md-4" id="v-step-1">
                        <div class="form-group">
                          <label for="title">
                            <span class="required">*</span> Titulo:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="workstations.title"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-4" id="v-step-2">
                        <div class="form-group">
                          <label for="userDepartment">
                            <span class="required">*</span> Empresa
                          </label>
                          <v-select
                            :options="companies"
                            label="company_name"
                            :reduce="(companies) => companies.id"
                            class="style-chooser"
                            v-model="workstations.company_id"
                            v-on:input="getBranches()"
                          >
                            <div slot="no-options">
                              Nenhum registro encontrado.
                            </div>
                          </v-select>
                        </div>
                      </div>
                      <div class="col-md-4" id="v-step-3">
                        <div class="form-group">
                          <label for="branch_id">
                            <span class="required">*</span> Filial/Prédio:
                          </label>
                          <v-select
                            :options="branches"
                            v-if="loadBranch"
                            label="title"
                            :reduce="(branches) => branches.id"
                            class="style-chooser"
                            v-model="workstations.branch_id"
                          >
                            <div slot="no-options">
                              Nenhum registro encontrado.
                            </div>
                          </v-select>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col-md-4" id="v-step-4">
                        <div class="form-group">
                          <label for="tag">
                            <span class="required">*</span> Tag:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="workstations.tag"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-2" id="v-step-5">
                        <div class="form-group">
                          <label for="numberRoom"> Nº da Estação: </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="workstations.number_room"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-2" id="v-step-6">
                        <div class="form-group">
                          <label for="floor"> Andar: </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="workstations.floor"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-4" id="v-step-7">
                        <div class="form-group">
                          <label for="capacity">
                            <span class="required">*</span> Quantidade de
                            Posições:
                          </label>
                          <input
                            type="number"
                            min="0"
                            oninput="validity.valid||(value='');"
                            class="form-control"
                            v-model="workstations.capacity"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-8" id="v-step-8">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Descrição:
                          </label>
                          <textarea
                            v-model="workstations.description"
                            name="description"
                            cols="100"
                            class="form-control"
                            rows="10"
                            placeholder=""
                            autocomplete="new-password"
                          ></textarea>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>
                            Grupos de usuário com permissão para reservar esta estação:
                          </label>
                          <v-select 
                          multiple
                          label="title"
                          v-model="workstations.users_groups"
                          :options=users_groups>
                          </v-select> 
                        </div>
                    </div>
                    </div>
                    <br />
                    <br />
                    <div class="row">
                      <div class="col-md-12" id="v-step-9">
                        <div class="form-group">
                          <label for="RoomDetails">Contém na Estação:</label>
                          <br />
                        </div>
                      </div>
                      <div
                        class="col-md-1 lg-check"
                        style="text-align: center"
                        v-for="detail in details"
                        :key="detail.id"
                      >
                        <input
                          type="checkbox"
                          :value="detail.id"
                          v-model="checkeds"
                          :id="detail.id"
                          @change="clear()"
                        />
                        <label :for="detail.id">{{ detail.title }}</label>
                      </div>
                    </div>
                    <br />
                    <br />
                    <hr />
                    <div class="row">
                      <div class="col-md-6">
                        <label for="roomPic" id="v-step-10">
                          <span class="required">*</span>Foto da Estação de
                          Trabalho
                        </label>
                        <br />
                        <div
                          class="inlinee"
                          v-for="(image, key) in images"
                          :key="key"
                        >
                          <img :src="image.preview" class="preview" />
                        </div>
                        <div></div>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="file"
                            id="roomPic"
                            accept="image/jpeg, image/png"
                            name="roomPic"
                            @change="uploadImage"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <label for="blueprint" id="v-step-11">
                          <span class="required">*</span>Planta Baixa do Andar
                        </label>
                        <div class="form-group">
                          <input
                            type="file"
                            id="blueprint"
                            accept="image/jpeg, image/png"
                            name="blueprint"
                          />
                        </div>
                      </div>
                    </div>
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <a class="btn btn-add" id="v-step-12" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                      <router-link to="/workstations" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                  <v-tour name="myTour" :steps="steps">
                    <template slot-scope="tour">
                      <transition name="fade">
                        <v-step
                          v-if="tour.currentStep === index"
                          v-for="(step1, index) of tour.steps"
                          :key="index"
                          :step="step1"
                          :previous-step="tour.previousStep"
                          :next-step="tour.nextStep"
                          :stop="tour.stop"
                          :skip="tour.skip"
                          :is-first="tour.isFirst"
                          :is-last="tour.isLast"
                          :labels="tour.labels"
                        >
                          <template>
                            <div slot="actions">
                              <button
                                v-if="tour.currentStep != 0"
                                @click="tour.previousStep"
                                class="btn-step-back"
                              >
                                Anterior
                              </button>
                              <button
                                @click="cancelTour(tour.currentStep)"
                                class="btn-step-back"
                              >
                                Pular tour
                              </button>
                              <button
                                @click="
                                  nextTour(
                                    tour.currentStep,
                                    tour.steps[index + 1],
                                    tour.steps[index]
                                  )
                                "
                                v-if="tour.currentStep != 12"
                                class="btn-step"
                              >
                                Próximo
                              </button>
                              <button
                                @click="cancelTour(tour.currentStep)"
                                v-else
                                class="btn-step"
                              >
                                Finalizar
                              </button>
                            </div>
                          </template>
                        </v-step>
                      </transition>
                    </template>
                  </v-tour>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Switch from "../Utils/Checked.vue";
import vSelect from "vue-select";
export default {
  data() {
    return {
      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Cadastrar Estação de Trabalho!",
          },
          params: {
            enableScrolling: false,
          },
          content: `Clique em <strong>próximo</strong> para continuar no tour. Caso não queira esse acompanhamento, clique em <strong>Pular tour</strong>. Se preferir poderá ver esse tour guiado a qualquer momento no botão destacado no menu superior.`,
        },
        {
          target: "#v-step-1",
          params: {
            enableScrolling: false,
          },
          content: "Insira um Título para a Estação de Trabalho",
        },
        {
          target: "#v-step-2",
          params: {
            enableScrolling: false,
          },
          content: "Insira uma Empresa para a Estação de Trabalho",
        },
        {
          target: "#v-step-3",
          params: {
            enableScrolling: false,
          },
          content: "Insira uma Filial/Prédio para a Estação de Trabalho",
        },
        {
          target: "#v-step-4",
          params: {
            enableScrolling: false,
          },
          content: "Insira uma Tag para a Estação de Trabalho",
        },
        {
          target: "#v-step-5",
          params: {
            enableScrolling: false,
          },
          content: "Insira uma Nº da Estação para a Estação de Trabalho",
        },
        {
          target: "#v-step-6",
          params: {
            enableScrolling: false,
          },
          content: "Insira um Andar da Estação para a Estação de Trabalho",
        },
        {
          target: "#v-step-7",
          params: {
            enableScrolling: false,
          },
          content: "Insira a Capacidade da Estação para a Estação de Trabalho",
        },
        {
          target: "#v-step-8",
          params: {
            enableScrolling: false,
          },
          content: "Insira uma Descrição da Estação para a Estação de Trabalho",
        },
        {
          target: "#v-step-9",
          params: {
            enableScrolling: false,
          },
          content: "Insira o que Contém na Estação para a Estação de Trabalho",
        },
        {
          target: "#v-step-10",
          params: {
            enableScrolling: false,
            placement: "right",
          },
          content: "Insira uma Foto da Estação para a Estação de Trabalho",
        },
        {
          target: "#v-step-11",
          params: {
            enableScrolling: false,
            placement: "right",
          },
          content: "Insira uma Foto da Planta da Estação de Trabalho.",
        },
        {
          target: "#v-step-12",
          params: {
            enableScrolling: false,
          },
          content:
            "Com todas as informações preenchidas clique em Salvar e sua Estação de Trabalho será criada.",
        },
      ],
      images: [],
      blueprint: [],
      workstations: {
        title: "",
        description: "",
        tag: "",
        floor: "",
        number_room: "",
        company_id: "",
        capacity: "",
        photo: "",
        branch_id: "",
        users_groups: [],
      },
      checkeds: [],
      companies: [],
      branches: [],
      users_groups: [],
      details: {
        selected: "",
      },
      details: "",
      loadBranch: true,
    };
  },
  methods: {
    cancelTour(step) {
      const self = this;
      self.$tours["myTour"].skip();
      self.$store.commit("skipTour");

      let data = { finished_step: step };

      const api = self.$store.state.api + "user/finish-tour";

      self.$http.post(api, data).then((response) => {});
    },
    nextTour(step, actual_target, previous_target) {
      const self = this;

      if (step >= 31) {
        if (step >= 31) {
          $(previous_target.target).toggleClass("activeMenu");
        }
        $(actual_target.target).toggleClass("activeMenu");
      }

      if (step == 31) {
        $("#sidebar").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#pagCads").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#sidebar").toggleClass("active");
        $("html, body").animate({ scrollTop: 0 }, 0);
        self.$tours["myTour"].nextStep();
      } else {
        self.$tours["myTour"].nextStep();
      }
    },
    startTour() {
      let self = this;
      self.$tours["myTour"].start();
    },
    makeFormData: function () {
      const self = this;
      let fd = new FormData();
      let photo = document.getElementById("roomPic");
      let blueprint = document.getElementById("blueprint");
      fd.append("title", self.workstations.title);
      fd.append("description", self.workstations.description);
      fd.append("tag", self.workstations.tag);
      fd.append("floor", self.workstations.floor);
      fd.append("number_room", self.workstations.number_room);
      fd.append("capacity", self.workstations.capacity);
      fd.append("branch_id", self.workstations.branch_id);
      fd.append("company_id", self.workstations.company_id);
      fd.append("details", self.checkeds);
      fd.append("photo", photo.files[0] ? photo.files[0] : "");
      fd.append("blueprint", blueprint.files[0] ? blueprint.files[0] : "");

      self.workstations.users_groups.forEach((user_group, index) => {
        fd.append("users_groups[" + index + "]", user_group.id);
      });

      if (self.$route.params.id) {
        fd.append("id", self.$route.params.id);
        fd.append("_method", "PUT");
      }
      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "workstations";
      let fd = self.makeFormData();
      if (self.$route.params.id) {
        api += "/" + self.$route.params.id;
      }
      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/workstations");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    uploadImage(e) {
      let vm = this;
      var selectedFiles = e.target.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        console.log(selectedFiles[i]);
        this.images.push({ file: selectedFiles[i], preview: "" });
      }

      for (let i = 0; i < this.images.length; i++) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.images[i].preview = e.target.result;
        };

        reader.readAsDataURL(this.images[i].file);
      }
    },
    uploadBlueprint(e) {
      let vm = this;
      var selectedFiles = e.target.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        console.log(selectedFiles[i]);
        this.blueprint.push({ file: selectedFiles[i], preview: "" });
      }

      for (let i = 0; i < this.blueprint.length; i++) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.blueprint[i].preview = e.target.result;
        };

        reader.readAsDataURL(this.blueprint[i].file);
      }
    },
    getWorkstationDetails: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "workstation_details/?paginated=false&company_id=" +
        id;

      self.$http
        .get(api)
        .then((response) => {
          self.details = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsersGroups: function (id) {
      const self = this;
      const api = self.$store.state.api + "users_groups/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.users_groups = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBranches: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "branches/?paginated=false&company_id=" +
        self.workstations.company_id;

      self.$http
        .get(api)
        .then((response) => {
          self.branches = response.data.data;
          console.log(self.branches);
          self.getWorkstationDetails(self.workstations.company_id);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getWorkstations: function () {
      let self = this;
      let id = self.$route.params.id;
      let api =
        self.$store.state.api + "workstations/" + id + "?with[]=details&with[]=users_groups";

      self.$http
        .get(api)
        .then((response) => {
          self.workstations = response.data.data[0];

          self.getWorkstationDetails(self.workstations.company_id);

          self.workstations.details.forEach((detail, index) => {
            self.checkeds.push(detail.detail_id);
          });
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getCompanies();
    self.getBranches();
    let id = self.$route.params.id;
    if (id) {
      self.getWorkstations(id);
    }

    self.getUsersGroups();
  },
  watch: {
    value(val) {
      this.text = val ? "Yes" : "No";
    },
  },
  components: {
    vSelect,
    "app-switch": Switch,
  },
};
</script>
<style scoped>
.photo {
  display: flex;
  border-radius: 20px;
  max-width: 400px;
  max-height: 200px;
  object-fit: cover;
}
.preview {
  display: inline-block;
  border-radius: 20px;
  max-width: 200px;
  max-height: 100px;
  object-fit: cover;
}
.inlinee {
  display: inline-block;
}

.lg-check {
  margin: 20px;
}

input[type="checkbox"] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

input[type="checkbox"] + label {
  font-size: 12px;
  padding: 2px 0 0;
  width: 100%;
  max-height: 100%;
  border: 2px solid #4b2e8f;
  border-radius: 0.25rem;
}
input[type="checkbox"]:checked + label {
  border: 2px solid #4b2e8f;
  color: #fff;
  background-color: #4b2e8f;
  font-style: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/Workstations/Add.vue